import React from "react";
import simboloPrimary from "../../assets/rebrand/simbolo-primary.png";

const Anywhere = () => {
  return (
    <div className="franjaBody col-12 pb-5 mt-5">
      <div className="row flex-xl-row-reverse align-items-center">
        <div style={{ zIndex: 1 }} className="col-12 col-sm-12 col-xl-8">
          <div className="text-container text-start container-fluid bg-dark py-5">
            <h1 className="text-accent">Aprende desde cualquier lugar</h1>
            <div className="text-white">
              <p>
                Te ofrecemos dos modalidades para que elijas la que mejor se
                adapta a tu ritmo, horarios y forma de aprender:
              </p>
              <img
                src="https://tbmcerts.s3.us-west-1.amazonaws.com/anywhere.png"
                alt=""
                className="aprende m-auto d-block d-md-none"
                style={{ zIndex: 10 }}
              />
              <div className="row row-cols-1 row-cols-md-2 g-3 g-lg-4">
                <div className="col d-flex">
                  <div
                    className="card bg-light border-0 shadow-sm h-100 w-100"
                    style={{ borderRadius: "25px" }}
                  >
                    <div className="card-body text-dark">
                      <b className="h4 bold d-block mb-3">
                        En vivo + 80 días on demand
                      </b>
                      <p>
                        Vive un fin de semana intensivo de 3 días guiado por
                        nuestras Master Coaches, con acompañamiento,
                        correcciones y práctica aplicada. Aprenderás la
                        metodología y la estructura del método para enseñar con
                        seguridad y confianza. Después, continúa con 80 días de
                        acceso on demand para repasar, practicar y consolidar lo
                        aprendido. Incluye las 3 disciplinas: Sculpt &amp; Burn
                        (Sculpt and Burn), Barre y Block Burn Pilates (BBP).
                      </p>
                      <p className="bold mb-1">Modalidad en vivo disponible en:</p>
                      <div className="row mb-0">
                        <div className="col-6">
                          <p className="italic mb-0 d-flex align-items-center">
                            <img
                              src={simboloPrimary}
                              alt=""
                              aria-hidden="true"
                              width="14"
                              height="14"
                              className="me-2"
                            />
                            <span>Presencial</span>
                          </p>
                          <p className="mb-0">En nuestro estudio</p>
                        </div>
                        <div className="col-6">
                          <p className="italic mb-0 d-flex align-items-center">
                            <img
                              src={simboloPrimary}
                              alt=""
                              aria-hidden="true"
                              width="14"
                              height="14"
                              className="me-2"
                            />
                            <span>Vía Zoom</span>
                          </p>
                          <p className="mb-0">Desde donde estés</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col d-flex">
                  <div
                    className="card bg-light border-0 shadow-sm h-100 w-100"
                    style={{ borderRadius: "25px" }}
                  >
                    <div className="card-body text-dark">
                      <b className="h4 bold d-block mb-3">
                        On demand (100% en línea)
                      </b>
                      <p>
                        Aprende de forma autónoma, a tu propio ritmo y desde
                        cualquier lugar. Accede cuando quieras, repite las
                        clases las veces que necesites y avanza a tu manera.
                      </p>
                      <p className="mb-1 bold">Certifícate en una, dos o tres disciplinas:</p>
                      <ul className="list-unstyled mb-0">
                        <li className="d-flex align-items-center mb-2">
                          <img
                            src={simboloPrimary}
                            alt=""
                            aria-hidden="true"
                            width="16"
                            height="16"
                            className="me-2"
                          />
                          <span>Sculpt and Burn (40 días)</span>
                        </li>
                        <li className="d-flex align-items-center mb-2">
                          <img
                            src={simboloPrimary}
                            alt=""
                            aria-hidden="true"
                            width="16"
                            height="16"
                            className="me-2"
                          />
                          <span>Sculpt and Burn + Barre (80 días)</span>
                        </li>
                        <li className="d-flex align-items-center">
                          <img
                            src={simboloPrimary}
                            alt=""
                            aria-hidden="true"
                            width="16"
                            height="16"
                            className="me-2"
                          />
                          <span>Sculpt and Burn + Barre + BBP (120 días)</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ zIndex: 2 }}
          className="col-12 col-sm-12 col-xl-4 text-center"
        >
          <img
            src="https://tbmcerts.s3.us-west-1.amazonaws.com/anywhere.png"
            alt=""
            className="aprende m-auto d-none d-md-block"
            style={{ zIndex: 10 }}
          />
        </div>
      </div>
    </div>
  );
};
export default Anywhere;
